<script lang="ts" setup>
export interface PagebuilderDocumentsProps {
    data: {
        documents: DocumentGroup[]
    }
}

const props = defineProps<PagebuilderDocumentsProps>()
</script>
<template>
  <div
    v-if="props.data.documents.length"
    class="mb-10"
  >
    <DocumentsTableSimple
      :data="props.data.documents"
      :caption="$t('Dokumenty')"
    />
  </div>
</template>
